import { tv } from 'tailwind-variants';

export const mobileMenuStyles = tv({
  slots: {
    container: `
      rounded-3xl
      bg-card backdrop-blur
      flex items-center justify-center
      overflow-hidden
      px-1
    `,
    items: `
      flex flex-row items-center justify-around
      flex-1
      gap-1
    `,
    item: `
      flex flex-col items-center justify-center
      flex-1
      py-4
      select-none
      transition-colors duration-200
      text-fg-muted
      hover:text-fg
      active:text-fg
    `,
    link: `
      flex flex-col flex-1 gap-2 items-center  text-left
      rounded-lg transition-colors duration-150 ease-in-out
      focus:outline-none
    `,
    icon: `
      text-lg leading-none
      transition-colors duration-200
    `,
    label: `
      text-xs leading-none font-medium
      transition-colors duration-200
    `,
  },
  variants: {
    active: {
      true: {},
    },
  },
  compoundVariants: [
    {
      active: true,
      class: {
        icon: 'text-primary font-medium',
        label: 'text-primary font-bold',
      },
    },
  ],
});
